module.exports = __webpack_public_path__ + "28b67065/img/note-list-icon.961c1485.svg";